import { P } from 'components'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap'

const ModalConfirmation = ({
  isModalOpen,
  handleCancelModal,
  handleConfirmLoadData,
  isLoading,
  isFetching,
}) => {
  return (
    <Modal isOpen={isModalOpen} toggle={handleCancelModal} centered data-testid="emp-pay-modal-confirm">
      <ModalHeader toggle={handleCancelModal}>
        Confirm Apply Auto-Calculation
      </ModalHeader>
      <ModalBody>
        <P size="regular" className="mb-2">
          Are you sure you want to apply the auto-calculated disbursement?
        </P>
        <P size="regular">
          Manual disbursements detected. If you continue, all previously set
          manual values will be overwritten by the new auto calculation data.
        </P>
      </ModalBody>
      <ModalFooter>
        <Button className="btn-cancel" onClick={handleCancelModal} data-testid="emp-pay-modal-confirm-cancel">
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleConfirmLoadData}
          disabled={isLoading || isFetching}
          data-testid="emp-pay-modal-confirm-submit"
        >
          {isLoading || (isFetching && <Spinner size="sm" className="me-2" />)}
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalConfirmation
